import { Route, Routes } from 'react-router-dom';
import { CompaniesPage } from './CompaniesPage';
import { ModifyCompanyPage } from './ModifyCompanyPage';

export const CompanyPageRoot = () => (
  <Routes>
    <Route path='/new' element={<ModifyCompanyPage />} />
    <Route path='/:companyID' element={<ModifyCompanyPage />} />
    <Route path='*' element={<CompaniesPage />} />
  </Routes>
);
